module.exports = __webpack_public_path__ + "static/media/goodnest_app3_preview.a9ef4443.jpg";